<!-- <ng-container *ngIf="screenWidth > 768"> -->
  <app-quote-step12-desktop [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep()" (onPrevStep)= "prevStep()"></app-quote-step12-desktop>
<!-- </ng-container>

<ng-container *ngIf="screenWidth <= 768">
  <app-quote-step12-mobile [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep()" (onPrevStep)= "prevStep()"></app-quote-step12-mobile>
</ng-container> -->